/*
 * AppConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const SET_CURRENT_JOB_DETAIL_ID = "app/App/SET_CURRENT_JOB_DETAIL_ID";
export const SET_CURRENT_CANDIDATE_ID = "app/App/SET_CURRENT_CANDIDATE_ID";
export const RESET_IDS = "app/App/RESET_IDS";
export const SET_ZR_JOB = "app/App/SET_ZR_JOB";

export const SET_USER_INPUT = "app/App/SET_USER_INPUT";

export const SET_REFRESH_PAGE = "app/App/SET_REFRESH_PAGE";
export const RESET_REFRESH_PAGE = "app/App/RESET_REFRESH_PAGE";
export const RESET_SEARCH_FILTERS = "app/App/RESET_SEARCH_FILTERS";

export const LOAD_SEARCH_FILTER_OPTIONS = "app/App/LOAD_SEARCH_FILTER_OPTIONS";
export const LOAD_SEARCH_FILTER_OPTIONS_SUCCESS =
  "app/App/LOAD_SEARCH_FILTER_OPTIONS_SUCCESS";
export const LOAD_SEARCH_FILTER_OPTIONS_ERROR =
  "app/App/LOAD_SEARCH_FILTER_OPTIONS_ERROR";

export const UPDATE_SEARCH_FILTERS = "app/App/UPDATE_SEARCH_FILTERS";
export const REMOVE_FILTER = "app/App/REMOVE_FILTER";

export const SET_SCHEDULING_JOB_DETAIL_ID =
  "app/App/SET_SCHEDULING_JOB_DETAIL_ID";
export const RESET_SCHEDULING_JOB_DETAIL_ID =
  "app/App/RESET_SCHEDULING_JOB_DETAIL_ID";

export const SHOW_SESSION_EXPIRATION_MODAL =
  "app/App/SHOW_SESSION_EXPIRATION_MODAL";

export const LOGIN = "app/App/LOGIN";
export const LOGIN_SUCCESS = "app/App/LOGIN_SUCCESS";
export const LOGIN_ERROR = "app/App/LOGIN_ERROR";

export const SHOW_LINKEDIN_AUTHORIZE_MODAL =
  "app/App/SHOW_LINKEDIN_AUTHORIZE_MODAL";
export const AUTHORIZE_LINKEDIN_INTEGRATION =
  "app/App/AUTHORIZE_LINKEDIN_INTEGRATION";
export const LINKEDIN_INTEGRATION_ERROR = "app/App/LINKEDIN_INTEGRATION_ERROR";
export const GET_LOGIN_TOKEN_LINKEDIN = "app/App/GET_LOGIN_TOKEN_LINKEDIN";
export const REMOVE_LOGIN_TOKEN_LINKEDIN =
  "app/App/REMOVE_LOGIN_TOKEN_LINKEDIN";

export const PARTNERS_LOGIN = "app/App/PARTNERS_LOGIN";
export const PARTNERS_LOGIN_SUCCESS = "app/App/PARTNERS_LOGIN_SUCCESS";
export const PARTNERS_LOGIN_ERROR = "app/App/PARTNERS_LOGIN_ERROR";

export const REFRESH_USER_DATA = "app/App/REFRESH_USER_DATA";
export const REFRESH_USER_DATA_SUCCESS = "app/App/REFRESH_USER_DATA_SUCCESS";
export const REFRESH_USER_DATA_ERROR = "app/App/REFRESH_USER_DATA_ERROR";
export const UPDATE_USER_DATA = "app/App/UPDATE_USER_DATA";

export const RESET_PASSWORD = "app/App/RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "app/App/RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "app/App/RESET_PASSWORD_ERROR";

export const CLEAR_RESET_PASSWORD_ERRORS =
  "app/App/CLEAR_RESET_PASSWORD_ERRORS";

export const GET_INVOICE = "app/App/GET_INVOICE";
export const GET_INVOICE_SUCCESS = "app/App/GET_INVOICE_SUCCESS";
export const GET_INVOICE_ERROR = "app/App/GET_INVOICE_ERROR";

export const GET_COMPANY_INFO = "app/App/GET_COMPANY_INFO";
export const GET_COMPANY_INFO_SUCCESS = "app/App/GET_COMPANY_INFO_SUCCESS";
export const GET_COMPANY_INFO_ERROR = "app/App/GET_COMPANY_INFO_ERROR";

export const GET_ROLES = "app/App/GET_ROLES";
export const GET_ROLES_SUCCESS = "app/App/GET_ROLES_SUCCESS";
export const GET_ROLES_ERROR = "app/App/GET_ROLES_ERROR";

export const GET_BILLING_INFO = "app/App/GET_BILLING_INFO";
export const GET_BILLING_INFO_SUCCESS = "app/App/GET_BILLING_INFO_SUCCESS";
export const GET_BILLING_INFO_ERROR = "app/App/GET_BILLING_INFO_ERROR";

export const GET_INVOICE_PRICING = "app/App/GET_INVOICE_PRICING";
export const GET_INVOICE_PRICING_SUCCESS =
  "app/App/GET_INVOICE_PRICING_SUCCESS";
export const GET_INVOICE_PRICING_ERROR = "app/App/GET_INVOICE_PRICING_ERROR";

export const SET_NEW_PASSWORD = "app/App/SET_NEW_PASSWORD";
export const SET_NEW_PASSWORD_SUCCESS = "app/App/SET_NEW_PASSWORD_SUCCESS";
export const SET_NEW_PASSWORD_ERROR = "app/App/SET_NEW_PASSWORD_ERROR";

export const UPDATE_PAID_THIS_SESSION = "app/App/UPDATE_PAID_THIS_SESSION";

export const REMOVE_RESET_PASSWORD_FLAG = "app/App/REMOVE_RESET_PASSWORD_FLAG";

export const SET_FROM_SEARCH_FLAG = "app/App/SET_FROM_SEARCH_FLAG";

export const SAVE_LAST_LOCATION = "app/App/SAVE_LAST_LOCATION";

export const UPDATE_COMPANY_DEFAULT_PIPELINE_ID =
  "app/App/UPDATE_COMPANY_DEFAULT_PIPELINE_ID";

export const GET_USERS = "app/APP/GET_USERS";
export const GET_USERS_SUCCESS = "app/APP/GET_USERS_SUCCESS";
export const GET_USERS_ERROR = "app/APP/GET_USERS_ERROR";

export const GET_SOURCES = "app/App/GET_SOURCES";
export const GET_SOURCES_SUCCESS = "app/App/GET_SOURCES_SUCCESS";
export const GET_SOURCES_ERROR = "app/App/GET_SOURCES_ERROR";

export const CREATE_SOURCE = "app/App/CREATE_SOURCE";
export const CREATE_SOURCE_SUCCESS = "app/App/CREATE_SOURCE_SUCCESS";
export const CREATE_SOURCE_ERROR = "app/App/CREATE_SOURCE_ERROR";

export const PARTNERS_FORGOT_PASSWORD = "app/App/PARTNERS_FORGOT_PASSWORD";
export const PARTNERS_FORGOT_PASSWORD_SUCCESS =
  "app/App/PARTNERS_FORGOT_PASSWORD_SUCCESS";
export const PARTNERS_FORGOT_PASSWORD_ERROR =
  "app/App/PARTNERS_FORGOT_PASSWORD_ERROR";

export const PARTNERS_SET_NEW_PASSWORD = "app/App/PARTNERS_SET_NEW_PASSWORD";
export const PARTNERS_SET_NEW_PASSWORD_SUCCESS =
  "app/App/PARTNERS_SET_NEW_PASSWORD_SUCCESS";
export const PARTNERS_SET_NEW_PASSWORD_ERROR =
  "app/App/PARTNERS_SET_NEW_PASSWORD_ERROR";

export const UPDATE_COMPANY_INFO = "app/App/UPDATE_COMPANY_INFO";

export const SHOW_NEW_JOB_MODAL = "app/App/SHOW_NEW_JOB_MODAL";

export const GET_IDENTITY_PROVIDER = "app/App/GET_IDENTITY_PROVIDER";
export const GET_IDENTITY_PROVIDER_SUCCESS =
  "app/App/GET_IDENTITY_PROVIDER_SUCCESS";
export const GET_IDENTITY_PROVIDER_ERROR =
  "app/App/GET_IDENTITY_PROVIDER_ERROR";

export const SSO_LOGIN = "app/App/SSO_LOGIN";
export const SSO_LOGIN_SUCCESS = "app/App/SSO_LOGIN_SUCCESS";
export const SSO_LOGIN_ERROR = "app/App/SSO_LOGIN_ERROR";

export const UPDATE_SOURCES_BY_LOCALE = "app/App/UPDATE_SOURCES_BY_LOCALE";

export const RESET_ERROR_CODE = "app/App/RESET_ERROR_CODE";

export const SETUP_FEATURE_FLAGS = "app/App/SETUP_FEATURE_FLAGS";

export const UPDATE_FIRST_TEAMS_LOGIN = "app/App/UPDATE_FIRST_TEAMS_LOGIN";
export const UPDATE_FIRST_TEAMS_LOGIN_SUCCESS =
  "app/App/UPDATE_FIRST_TEAMS_LOGIN_SUCCESS";
export const UPDATE_FIRST_TEAMS_LOGIN_ERROR =
  "app/App/UPDATE_FIRST_TEAMS_LOGIN_ERROR";

export const SET_ORDER_IN_PROCESS = "app/App/SET_ORDER_IN_PROCESS";
export const RESET_ORDER_IN_PROCESS = "app/App/RESET_ORDER_IN_PROCESS";

export const DELETE_CANDIDATE = "app/App/DELETE_CANDIDATE";
export const DELETE_CANDIDATE_SUCCESS = "app/App/DELETE_CANDIDATE_SUCCESS";
export const DELETE_CANDIDATE_ERROR = "app/App/DELETE_CANDIDATE_ERROR";

export const RESET_DELETE_CANDIDATE_SUCCESS =
  "app/App/RESET_DELETE_CANDIDATE_SUCCESS";
export const UPDATE_VHS = "app/App/UPDATE_VHS";

export const SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID =
  "app/App/SET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID";

export const RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID =
  "app/App/RESET_CURRENT_VIDEO_INTERVIEW_TEMPLATE_ID";

export const GET_DYNAMIC_SCORE_REPORTS_DATA =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_DATA";
export const GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_DATA_SUCCESS";
export const GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_DATA_ERROR";

export const GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES";
export const GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_SUCCESS";
export const GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR =
  "app/App/GET_DYNAMIC_SCORE_REPORTS_WORK_STYLES_ERROR";

export const FORCE_LOGOUT = "app/App/FORCE_LOGOUT";
export const CLEAR_FORCE_LOGOUT = "app/App/CLEAR_FORCE_LOGOUT";

export const SET_JOB_CREATION_INFO = "app/App/SET_JOB_CREATION_INFO";

export const GET_TEST_BATTERIES = "app/App/GET_TEST_BATTERIES";
export const GET_TEST_BATTERIES_SUCCESS = "app/App/GET_TEST_BATTERIES_SUCCESS";
export const GET_TEST_BATTERIES_ERROR = "app/App/GET_TEST_BATTERIES_ERROR";

export const SET_VI_MERCHANDISING_MODAL = "app/App/SET_VI_MERCHANDISING_MODAL";

export const SET_INTERVIEW_TEMPLATE_CREATION_INFO =
  "app/App/SET_INTERVIEW_TEMPLATE_CREATION_INFO";

export const RESET_INTERVIEW_TEMPLATE_CREATION_INFO =
  "app/App/RESET_INTERVIEW_TEMPLATE_CREATION_INFO";

export const SEND_SUPPORT_BOT_QUESTION = "app/App/SEND_SUPPORT_BOT_QUESTION";
export const SEND_SUPPORT_BOT_QUESTION_SUCCESS =
  "app/App/SEND_SUPPORT_BOT_QUESTION_SUCCESS";
export const SEND_SUPPORT_BOT_QUESTION_ERROR =
  "app/App/SEND_SUPPORT_BOT_QUESTION_ERROR";

export const SEND_RESPONSE_FEEDBACK = "app/App/SEND_RESPONSE_FEEDBACK";
export const SEND_RESPONSE_FEEDBACK_SUCCESS =
  "app/App/SEND_RESPONSE_FEEDBACK_SUCCESS";
export const SEND_RESPONSE_FEEDBACK_ERROR =
  "app/App/SEND_RESPONSE_FEEDBACK_ERROR";

export const RESET_SUPPORT_BOT_RESPONSE = "app/App/RESET_SUPPORT_BOT_RESPONSE";

export const GET_CANDIDATE_ANALYTICS = "app/App/GET_CANDIDATE_ANALYTICS";
export const GET_CANDIDATE_ANALYTICS_SUCCESS =
  "app/App/GET_CANDIDATE_ANALYTICS_SUCCESS";
export const GET_CANDIDATE_ANALYTICS_ERROR =
  "app/App/GET_CANDIDATE_ANALYTICS_ERROR";

export const GET_PREV_CANDIDATE_ANALYTICS =
  "app/App/GET_PREV_CANDIDATE_ANALYTICS";
export const GET_PREV_CANDIDATE_ANALYTICS_SUCCESS =
  "app/App/GET_PREV_CANDIDATE_ANALYTICS_SUCCESS";
export const GET_PREV_CANDIDATE_ANALYTICS_ERROR =
  "app/App/GET_PREV_CANDIDATE_ANALYTICS_ERROR";

export const GET_ASSESSMENT_ANALYTICS = "app/App/GET_ASSESSMENT_ANALYTICS";
export const GET_ASSESSMENT_ANALYTICS_SUCCESS =
  "app/App/GET_ASSESSMENT_ANALYTICS_SUCCESS";
export const GET_ASSESSMENT_ANALYTICS_ERROR =
  "app/App/GET_ASSESSMENT_ANALYTICS_ERROR";

export const GET_PREV_ASSESSMENT_ANALYTICS =
  "app/App/GET_PREV_ASSESSMENT_ANALYTICS";
export const GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS =
  "app/App/GET_PREV_ASSESSMENT_ANALYTICS_SUCCESS";
export const GET_PREV_ASSESSMENT_ANALYTICS_ERROR =
  "app/App/GET_PREV_ASSESSMENT_ANALYTICS_ERROR";

export const GET_STRUCTURED_INTERVIEW_ANALYTICS =
  "app/App/GET_STRUCTURED_INTERVIEW_ANALYTICS";
export const GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS =
  "app/App/GET_STRUCTURED_INTERVIEW_ANALYTICS_SUCCESS";
export const GET_STRUCTURED_INTERVIEW_ANALYTICS_ERROR =
  "app/App/GET_STRUCTURED_INTERVIEW_ANALYTICS_ERROR";

export const GET_SCORE_RANGE_ANALYTICS = "app/App/GET_SCORE_RANGE_ANALYTICS";
export const GET_SCORE_RANGE_ANALYTICS_SUCCESS =
  "app/App/GET_SCORE_RANGE_ANALYTICS_SUCCESS";
export const GET_SCORE_RANGE_ANALYTICS_ERROR =
  "app/App/GET_SCORE_RANGE_ANALYTICS_ERROR";

export const GET_BUSINESS_VALUE = "app/App/GET_BUSINESS_VALUE";
export const GET_BUSINESS_VALUE_SUCCESS = "app/App/GET_BUSINESS_VALUE_SUCCESS";
export const GET_BUSINESS_VALUE_ERROR = "app/App/GET_BUSINESS_VALUE_ERROR";

export const SET_ANALYTICS_REQUESTED = "app/App/SET_ANALYTICS_REQUESTED";

export const CLEAR_CUSTOM_DATE_ANALYTICS =
  "app/App/CLEAR_CUSTOM_DATE_ANALYTICS";

export const SET_PASSWORD = "app/App/SET_PASSWORD";
export const SET_PASSWORD_SUCCESS = "app/App/SET_PASSWORD_SUCCESS";
export const SET_PASSWORD_ERROR = "app/App/SET_PASSWORD_ERROR";

export const RESEND_VERIFICATION_EMAIL = "app/App/RESEND_VERIFICATION_EMAIL";
export const RESEND_VERIFICATION_EMAIL_SUCCESS =
  "app/App/RESEND_VERIFICATION_EMAIL_SUCCESS";
export const RESEND_VERIFICATION_EMAIL_ERROR =
  "app/App/RESEND_VERIFICATION_EMAIL_ERROR";

export const CHECK_VALID_VERIFY_TOKEN = "app/App/CHECK_VALID_VERIFY_TOKEN";
export const CHECK_VALID_VERIFY_TOKEN_SUCCESS =
  "app/App/CHECK_VALID_VERIFY_TOKEN_SUCCESS";
export const CHECK_VALID_VERIFY_TOKEN_ERROR =
  "app/App/CHECK_VALID_VERIFY_TOKEN_ERROR";

/* Test Type List with their associated Test Ids */
export const aptitudeTestIdList = [
  10, 14, 16, 23, 37, 42, 43, 45, 47, 52, 56, 59
  // LAST LINE - DO NOT MOVE THIS COMMENT Aptitude
];

export const personalityTestIdList = [
  13, 15, 24, 29, 34, 50, 48,
  // LAST LINE - DO NOT MOVE THIS COMMENT Personality
];

export const emotionalTestIdList = [
  44, 51,
  // LAST LINE - DO NOT MOVE THIS COMMENT Emotional
];

export const skillTestIdList = [
  12, 17, 18, 19, 20, 21, 22, 30, 32, 33, 35, 36, 38, 39, 40, 41, 49, 53, 54,
  55, 57,
  // LAST LINE - DO NOT MOVE THIS COMMENT Skills
];

export const riskTestIdList = [
  31, 46,
  // LAST LINE - DO NOT MOVE THIS COMMENT Risk
];

/* We are using a constant here instead of a library so that we can have a minimal time zone list and not have the 500+ lists.
 * Since we really only need the label and tzCode, the other libraries that I have found are either too big dependency wise or
 * there is too much un needed code when all we need is a relatively small list of the major timezones.
 * Available Timezones: https://www.php.net/manual/en/timezones.php
 */
export const timeZoneList = [
  {
    label: "Lagos Time",
    tzCode: "Africa/Lagos",
  },
  {
    label: "Alaska Time",
    tzCode: "America/Anchorage",
  },
  {
    label: "Buenos Aires Time",
    tzCode: "America/Argentina/Buenos_Aires",
  },
  {
    label: "Colombia Time",
    tzCode: "America/Bogota",
  },
  {
    label: "Venezuelan Standard Time",
    tzCode: "America/Caracas",
  },
  {
    label: "Central Time",
    tzCode: "America/Chicago",
  },
  {
    label: "Mountain Time",
    tzCode: "America/Denver",
  },
  {
    label: "Atlantic Time - Halifax",
    tzCode: "America/Halifax",
  },
  {
    label: "Pacific Time",
    tzCode: "America/Los_Angeles",
  },
  {
    label: "Central Time - Mexico City",
    tzCode: "America/Mexico_City",
  },
  {
    label: "Eastern Time",
    tzCode: "America/New_York",
  },
  {
    label: "Sao Paulo Time",
    tzCode: "America/Sao_Paulo",
  },
  {
    label: "Bangkok Time",
    tzCode: "Asia/Bangkok",
  },
  {
    label: "Beirut Time",
    tzCode: "Asia/Beirut",
  },
  {
    label: "India Standard Time",
    tzCode: "Asia/Calcutta",
  },
  {
    label: "Dhaka Time",
    tzCode: "Asia/Dhaka",
  },
  {
    label: "Dubai Time",
    tzCode: "Asia/Dubai",
  },
  {
    label: "Hong Kong Time",
    tzCode: "Asia/Hong_Kong",
  },
  {
    label: "Jakarta Time",
    tzCode: "Asia/Jakarta",
  },
  {
    label: "Kabul Time",
    tzCode: "Asia/Kabul",
  },
  {
    label: "Pakistan Standard Time - Islamabad",
    tzCode: "Asia/Karachi",
  },
  {
    label: "Kathmandu Time",
    tzCode: "Asia/Kathmandu",
  },
  {
    label: "Kingdom of Saudi Arabia Time",
    tzCode: "Asia/Riyadh",
  },
  {
    label: "Singapore Time",
    tzCode: "Asia/Singapore",
  },
  {
    label: "Beijing Time",
    tzCode: "Asia/Shanghai",
  },
  {
    label: "Korea Standard Time",
    tzCode: "Asia/Seoul",
  },
  {
    label: "Tokyo Time",
    tzCode: "Asia/Tokyo",
  },
  {
    label: "Azores Time",
    tzCode: "Atlantic/Azores",
  },
  {
    label: "Central Time - Adelaide",
    tzCode: "Australia/Adelaide",
  },
  {
    label: "Eastern Time - Brisbane",
    tzCode: "Australia/Brisbane",
  },
  {
    label: "Central Time - Darwin",
    tzCode: "Australia/Darwin",
  },
  {
    label: "Western Time - Perth",
    tzCode: "Australia/Perth",
  },
  {
    label: "Eastern Time - Melbourne, Sydney",
    tzCode: "Australia/Sydney",
  },
  {
    label: "Berlin Time",
    tzCode: "Europe/Berlin",
  },
  {
    label: "Brussels Time",
    tzCode: "Europe/Brussels",
  },
  {
    label: "Helsinki Time",
    tzCode: "Europe/Helsinki",
  },
  {
    label: "Istanbul Time",
    tzCode: "Europe/Istanbul",
  },
  {
    label: "London Time",
    tzCode: "Europe/London",
  },
  {
    label: "Madrid Time",
    tzCode: "Europe/Madrid",
  },
  {
    label: "Paris Time",
    tzCode: "Europe/Paris",
  },
  {
    label: "Prague Time",
    tzCode: "Europe/Prague",
  },
  {
    label: "Zurich Time",
    tzCode: "Europe/Zurich",
  },
  {
    label: "Cocos Time",
    tzCode: "Indian/Cocos",
  },
  {
    label: "Maldives Time",
    tzCode: "Indian/Maldives",
  },
  {
    label: "Auckland Time",
    tzCode: "Pacific/Auckland",
  },
  {
    label: "Hawaii Time",
    tzCode: "Pacific/Honolulu",
  },
  {
    label: "Kiritimati Time",
    tzCode: "Pacific/Kiritimati",
  },
  {
    label: "Nauru Time",
    tzCode: "Pacific/Nauru",
  },
  {
    label: "Pago Pago Time",
    tzCode: "Pacific/Pago_Pago",
  },
  {
    label: "Tahiti Time",
    tzCode: "Pacific/Tahiti",
  },
];

// Function ran to sort the timeZoneList sorts by tzCode.
// timeZoneList.sort(
//   (e1, e2) =>
//     e1.tzCode.localeCompare(e2.tzCode) || e1.label.localeCompare(e2.label)
// );

export const TRACK_POSTHIRE_LOGIN = "app/App/TRACK_POSTHIRE_LOGIN";
export const TRACK_POSTHIRE_LOGIN_SUCCESS =
  "app/App/TRACK_POSTHIRE_LOGIN_SUCCESS";
export const TRACK_POSTHIRE_LOGIN_ERROR = "app/App/TRACK_POSTHIRE_LOGIN_ERROR";
